import React, { memo } from 'react'

function calcIndividualPercentages(...values) {
	const max = Math.max(...values)

	if (max > 0) return values.map((v) => `${(100.0 * v) / max}%`)
	else return values.map(() => '0%')
}

const BarIndividual = memo(({ name, icon, player1, player2, leftColor, rightColor }) => {
	const factors = calcIndividualPercentages(player1, player2)
	const leftState = player1 >= player2 ? 'winner' : 'loser'
	const rightState = player2 >= player1 ? 'winner' : 'loser'

	return (
		<div className={`barIndividual barIndividual--${name.toLowerCase().replace(/\s+/g, '-')}`}>
			<div className="barIndividual__label">
				{icon && <img className="barIndividual__icon" src={icon} alt="" />}
				{name}
			</div>
			<div className={`barIndividual__player barIndividual__leftPlayer barIndividual__player--${leftState}`}>
				<div className="barIndividual__number">{parseInt(player1).toLocaleString()}</div>
				<div className="barIndividual__bar">
					<div className="barIndividual__fill" style={{ '--fill': factors[0], backgroundColor: leftColor }} />
				</div>
			</div>
			<div className={`barIndividual__player barIndividual__rightPlayer barIndividual__player--${rightState}`}>
				<div className="barIndividual__number">{parseInt(player2).toLocaleString()}</div>
				<div className="barIndividual__bar">
					<div className="barIndividual__fill" style={{ '--fill': factors[1], backgroundColor: rightColor }} />
				</div>
			</div>
		</div>
	)
})

export { BarIndividual }
